import React, { useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import Dropdown from "../../../../../components/Dropdown/Dropdown";
import { useNavigate, useParams } from "react-router-dom";
import { addNewResult } from "../../../../../redux/features/results/resultService";

const Dhni = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const { isResultCreating } = useSelector((state) => state.result.newResult);

    const [formData, setFormData] = useState({
        char1: '',
        char2: '',
        n1: '',
        n2: '',
        h3: '',
        n4: '',
        special: '',
        next_mega_prize: '',
    });

    const [errorMessages, setErrorMessages] = useState({});
    const [disabledBtn, setBtnDisable] = useState(false);
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    // Validate input
    const isValidResult = () => {
        const errors = {};
        if (!formData.n1) {
            errors.n1 = "N1 is required.";
        }
        if (!formData.n2) {
            errors.n2 = "N2 is required.";
        } 
         if (!formData.n3) {
            errors.n3 = "N3 is required.";
        } 
         if (!formData.n4) {
            errors.n4 = "N4 is required.";
        } 
         if (!formData.special) {
            errors.special = "Special Number is required.";
        } 
         if (!formData.char1) {
            errors.char1 = "Character is required.";
        } else if (((formData.char1.trim()).length !== 1)) {
            errors.char1 = "Character contains only one letter.";
        }        
        if (!formData.next_mega_prize) {
            errors.next_mega_prize = "Next Mega Prize is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const insertNewResults = async () => {
        if (isValidResult()) {
            setBtnDisable(true);
            try {
                const data = {
                    lottery_id: id,
                    next_mega_prize: Number(formData.next_mega_prize).toLocaleString(),
                    create_dhni_result_dto: {
                        char1: formData.char1,
                        char2: 'char2',
                        n1: formData.n1,
                        n2: formData.n2,
                        n3: formData.n3,
                        n4: formData.n4,
                        special: formData.special,
                    }
                }
                const response = await dispatch(addNewResult(data)).unwrap();
                setBtnDisable(false);
                setFormData({
                     n1: '',
                     n2: '',
                     h3: '',
                     n4: '',
                     special: '',
                     char1:'',
                    next_mega_prize: '',
                });
                showToast('success', response.message);
                navigate('/admin/listing');
            }
            catch (error) {
                setBtnDisable(false);
                showToast('error', error.message);
            };
        }
    };

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Add Results</h1>
                <div className={styles.formContainer}>
                    <form
                        className={styles.coordinatorForm}
                        noValidate
                    >
                         <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Character<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='char1'
                                        name='char1'
                                        value={formData.char1 ||''}
                                        onChange={(e) => {
                                            const value = e.target.value.toUpperCase();
                                            const isEnglishLetters = /^[A-Z]*$/.test(value);
                                            if (isEnglishLetters) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter Character'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.char1 && (
                                        <p className={`text-danger`}>{errorMessages.char1}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        N1<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='n1'
                                        name='n1'
                                        value={formData.n1 ||''}
                                         onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyNumbers = /^[0-9]*$/;
                                            if (onlyNumbers.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter N1'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.n1 && (
                                        <p className={`text-danger`}>{errorMessages.n1}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                          <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        N2<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='n2'
                                        name='n2'
                                        value={formData.n2 ||''}
                                         onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyNumbers = /^[0-9]*$/;
                                            if (onlyNumbers.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter N2'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.n2 && (
                                        <p className={`text-danger`}>{errorMessages.n2}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                          <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        N3<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='n3'
                                        name='n3'
                                        value={formData.n3 ||''}
                                         onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyNumbers = /^[0-9]*$/;
                                            if (onlyNumbers.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter N3'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.n3 && (
                                        <p className={`text-danger`}>{errorMessages.n3}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                          <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        N4<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='n4'
                                        name='n4'
                                        value={formData.n4 ||''}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyNumbers = /^[0-9]*$/;
                                            if (onlyNumbers.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter N4'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.n4 && (
                                        <p className={`text-danger`}>{errorMessages.n4}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Special<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='special'
                                        name='special'
                                        value={formData.special || ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyNumbers = /^[0-9]*$/;
                                            if (onlyNumbers.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter Special Number'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.special && (
                                        <p className={`text-danger`}>{errorMessages.special}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                         <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor="megaPrice" className={`form-label`}>
                                        Next Mega Prize<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="next_mega_prize"
                                        name="next_mega_prize"
                                        value={formData.next_mega_prize}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 0)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder="Enter Next Mega Prize"
                                        className={`form-input-default`}
                                        min={0}
                                    />
                                    {errorMessages.next_mega_prize && (
                                        <p className={`text-danger`}>{errorMessages.next_mega_prize}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <button
                            className={`btn-primary`}
                            type='button'
                            disabled={disabledBtn}
                            onClick={insertNewResults}
                        >
                            {isResultCreating ? <BeatLoader color='#ffffff' /> : `Create`}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Dhni;